import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { AuthenticationReducer as Authentication } from '../../commons/reduxModules/Authentication';

import AppCMP, { reducerName } from './ConsentManagementPlatform';

export default function getReducer(history) {
    return combineReducers({
        // Globals
        router: connectRouter(history),
        Authentication,
        // App Reducer
        [reducerName]: AppCMP,
    });
}
